// src/components/auth/LoginLink.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Button from '../ui/Button';

export default function LoginLink({
  children = 'Log in',
  className = '',
  variant = 'primary',
  size = 'md',
}) {
  const { pathname, search } = useLocation();
  const next = encodeURIComponent(pathname + search);

  return (
    <Button
      as="link"
      to={`/login?next=${next}`}
      variant={variant}
      size={size}
      className={className}
    >
      {children}
    </Button>
  );
}